"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarExplore = exports.SidebarExploreTab = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./SidebarExplore.css"));
var VideoTab_1 = require("./Video/VideoTab");
var VideoExploreDataStore_1 = require("./Video/VideoExploreDataStore");
var SidebarExploreContext_1 = require("./SidebarExploreContext");
var inversify_react_1 = require("inversify-react");
var Types_1 = require("@CommonFrontendBackend/AssetLibrary/Types");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var Types_2 = require("../Types");
var BlocksTab_1 = require("./Blocks/BlocksTab");
var BlocksExploreDataStore_1 = require("./Blocks/BlocksExploreDataStore");
var lodash_1 = require("lodash");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var UnsplashImageDataStore_1 = require("Project/ContentSidebar/Explore/Image/UnsplashImage/UnsplashImageDataStore");
var UnsplashDataStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/Unsplash/UnsplashDataStore"));
var UnsplashCollectionDataStore_1 = require("Project/ContentSidebar/Explore/Image/UnsplashCollection/UnsplashCollectionDataStore");
var ImageTab_1 = require("Project/ContentSidebar/Explore/Image/ImageTab");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var SearchBar_1 = require("./SearchBar");
var Types_3 = require("Project/ContentSidebar/Explore/Types");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var AllTab_1 = require("Project/ContentSidebar/Explore/All/AllTab");
var SidebarExploreTab;
(function (SidebarExploreTab) {
    SidebarExploreTab["All"] = "all";
    SidebarExploreTab["Images"] = "images";
    SidebarExploreTab["Blocks"] = "blocks";
    SidebarExploreTab["Videos"] = "videos";
})(SidebarExploreTab || (exports.SidebarExploreTab = SidebarExploreTab = {}));
exports.SidebarExplore = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var openImageLibrary = _a.openImageLibrary, fileInputRef = _a.fileInputRef, onUpload = _a.onUpload;
    var clickToAddStore = (0, inversify_react_1.useInjection)("clickToAddStore");
    var dragStore = (0, inversify_react_1.useInjection)("dragStore");
    var dropLocationStore = (0, inversify_react_1.useInjection)("dropLocationStore");
    var blockList = (0, inversify_react_1.useInjection)("blockList");
    var insertBlock = (0, inversify_react_1.useInjection)("insertBlock");
    var videoEmbedUrlGenerator = (0, inversify_react_1.useInjection)("videoEmbedUrlGenerator");
    var sidebarTelemetry = (0, inversify_react_1.useInjection)("contentSidebarTelemetry");
    var unsplashImageService = (0, inversify_react_1.useInjection)("imageService");
    var stockImageService = (0, inversify_react_1.useInjection)("stockImageService");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var sidebarExploreViewStore = (0, inversify_react_1.useInjection)("sidebarExploreViewStore");
    var _c = __read((0, react_1.useState)(""), 2), searchTerm = _c[0], setSearchTerm = _c[1];
    var searchBarRef = react_1.default.useRef();
    var _d = __read((0, react_1.useState)("0px"), 2), searchBarHeight = _d[0], setSearchBarHeight = _d[1];
    var sidebarTabOrder = __spreadArray(__spreadArray([], __read((0, CommonUtils_1.includeIf)(usingFeature(FeatureFlag_1.default.NewSidebarExploreSearch), [SidebarExploreTab.All])), false), [
        SidebarExploreTab.Blocks,
        SidebarExploreTab.Images,
        SidebarExploreTab.Videos,
    ], false);
    var handleClickToAddBlock = function (asset, telemetry) { return __awaiter(void 0, void 0, void 0, function () {
        var blockModel;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    blockModel = cleanBlockData(asset);
                    return [4, insertBlock(function (block) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, blockList.insertBlockAtIndex(block, 0, { insertDelayMs: 0 })];
                                    case 1: return [2, _a.sent()];
                                }
                            });
                        }); })(blockModel)];
                case 1:
                    _a.sent();
                    sidebarTelemetry.sidebarAssetAdded({
                        assetType: TelemetryEnums_1.SidebarAssetAddedType.Block,
                        insertMethod: TelemetryEnums_1.SidebarAssetAddedInsertMethod.Click,
                        source: "explore",
                        secondarySource: telemetry.tab,
                    });
                    return [2];
            }
        });
    }); };
    var throttledClickToAddBlock = (0, lodash_1.throttle)(function (asset, tab) { return handleClickToAddBlock(asset, tab); }, 1000);
    var handleClickToAddImage = function (asset, telemetry) {
        var mediaData = getMediaDataForUnsplashImage(asset);
        clickToAddStore.clickToAdd({
            mediaData: mediaData,
            mediaSource: Types_1.MediaSource.Explore,
            telemetryData: { view: "explore", tab: telemetry.tab, originWasFiltered: telemetry.withSearchTerm },
        });
    };
    var throttledClickToAddImage = (0, lodash_1.throttle)(function (asset, tab) { return handleClickToAddImage(asset, tab); }, 1000);
    var handleClickToAddVideo = function (asset, telemetry) { return __awaiter(void 0, void 0, void 0, function () {
        var mediaData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getMediaDataForVideo(asset, videoEmbedUrlGenerator)];
                case 1:
                    mediaData = _a.sent();
                    clickToAddStore.clickToAdd({
                        mediaData: mediaData,
                        mediaSource: Types_1.MediaSource.Explore,
                        telemetryData: { view: "explore", tab: telemetry.tab, originWasFiltered: telemetry.withSearchTerm },
                    });
                    return [2];
            }
        });
    }); };
    var throttledClickToAddVideo = (0, lodash_1.throttle)(function (asset, tab) { return handleClickToAddVideo(asset, tab); }, 1000);
    (0, react_1.useEffect)(function () {
        if (searchBarRef.current) {
            setSearchBarHeight("".concat(searchBarRef.current.clientHeight, "px"));
        }
    }, []);
    (0, react_1.useEffect)(function () {
        return function () {
            throttledClickToAddBlock === null || throttledClickToAddBlock === void 0 ? void 0 : throttledClickToAddBlock.cancel();
            throttledClickToAddImage === null || throttledClickToAddImage === void 0 ? void 0 : throttledClickToAddImage.cancel();
            throttledClickToAddVideo === null || throttledClickToAddVideo === void 0 ? void 0 : throttledClickToAddVideo.cancel();
        };
    }, [throttledClickToAddBlock, throttledClickToAddImage, throttledClickToAddVideo]);
    var clickToAddCommonHandler = function (asset, telemetry) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(0, Types_3.isAssetBlock)(asset)) return [3, 2];
                    return [4, throttledClickToAddBlock(asset, telemetry)];
                case 1:
                    _a.sent();
                    return [3, 5];
                case 2:
                    if (!(0, Types_3.isAssetUnsplash)(asset)) return [3, 3];
                    throttledClickToAddImage(asset, telemetry);
                    return [3, 5];
                case 3:
                    if (!(0, Types_3.isAssetVideo)(asset)) return [3, 5];
                    return [4, throttledClickToAddVideo(asset, telemetry)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2];
            }
        });
    }); };
    var dragStartCommonHandler = function (asset, telemetry) { return __awaiter(void 0, void 0, void 0, function () {
        var blockModel, mediaData, mediaData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(asset.type === Types_2.AssetType.Block)) return [3, 1];
                    blockModel = cleanBlockData(asset);
                    dragStore.startDrag([
                        {
                            type: DragStore_1.DragType.SidebarBlockModel,
                            blockModel: blockModel,
                            mediaSource: Types_1.MediaSource.Explore,
                            telemetryData: { view: "explore", tab: telemetry.tab },
                        },
                    ]);
                    return [3, 4];
                case 1:
                    if (!(asset.type === Types_2.AssetType.UnsplashImage)) return [3, 2];
                    mediaData = getMediaDataForUnsplashImage(asset);
                    dragStore.startDrag([
                        {
                            type: DragStore_1.DragType.SidebarImage,
                            mediaData: mediaData,
                            mediaSource: Types_1.MediaSource.Explore,
                            telemetryData: { view: "explore", tab: telemetry.tab, originWasFiltered: telemetry.withSearchTerm },
                        },
                    ]);
                    return [3, 4];
                case 2:
                    if (!(asset.type === Types_2.AssetType.Video)) return [3, 4];
                    return [4, getMediaDataForVideo(asset, videoEmbedUrlGenerator)];
                case 3:
                    mediaData = _a.sent();
                    dragStore.startDrag([
                        {
                            type: DragStore_1.DragType.SidebarVideo,
                            mediaData: mediaData,
                            mediaSource: Types_1.MediaSource.Explore,
                            telemetryData: { view: "explore", tab: telemetry.tab, originWasFiltered: telemetry.withSearchTerm },
                        },
                    ]);
                    _a.label = 4;
                case 4: return [2];
            }
        });
    }); };
    return (react_1.default.createElement(SidebarExploreContext_1.SidebarExploreContext.Provider, { value: {
            videoExploreDataStore: new VideoExploreDataStore_1.VideoExploreDataStore(),
            blockExploreDataStore: new BlocksExploreDataStore_1.BlocksExploreDataStore(),
            unsplashImageDataStore: new UnsplashImageDataStore_1.UnsplashImageDataStore(new UnsplashDataStore_1.default(unsplashImageService, stockImageService)),
            unsplashCollectionDataStore: new UnsplashCollectionDataStore_1.UnsplashCollectionDataStore(new UnsplashDataStore_1.default(unsplashImageService, stockImageService)),
            searchTerm: searchTerm,
        } },
        react_1.default.createElement(kaleidoscope_1.Stack, { paddingTop: "l", className: styles.exploreContainer, style: (0, dynamic_1.assignInlineVars)((_b = {}, _b[styles.searchBarHeight] = searchBarHeight, _b)) },
            usingFeature(FeatureFlag_1.default.NewSidebarExploreSearch) && (react_1.default.createElement(SearchBar_1.SearchBar, { tab: sidebarExploreViewStore.currentTab, setSearchTerm: setSearchTerm, componentRef: searchBarRef })),
            react_1.default.createElement(kaleidoscope_1.Tabs, { selectedIndex: sidebarTabOrder.findIndex(function (t) { return t === sidebarExploreViewStore.currentTab; }), onChange: function (index) {
                    var nextTab = sidebarTabOrder[index];
                    if (nextTab) {
                        sidebarExploreViewStore.setTab(nextTab);
                    }
                } },
                react_1.default.createElement(kaleidoscope_1.TabList, { "aria-label": "Content types", className: styles.tabList },
                    usingFeature(FeatureFlag_1.default.NewSidebarExploreSearch) && react_1.default.createElement(kaleidoscope_1.Tab, null, "All"),
                    react_1.default.createElement(kaleidoscope_1.Tab, null, "Blocks"),
                    react_1.default.createElement(kaleidoscope_1.Tab, null, "Images"),
                    react_1.default.createElement(kaleidoscope_1.Tab, null, "Videos")),
                react_1.default.createElement(kaleidoscope_1.TabPanels, null,
                    usingFeature(FeatureFlag_1.default.NewSidebarExploreSearch) && (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                        react_1.default.createElement(AllTab_1.AllTab, { setTab: sidebarExploreViewStore.setTab, onClickToAdd: clickToAddCommonHandler, onDragAssetStart: dragStartCommonHandler, onDragAssetEnd: function () {
                                dragStore.stopDrag();
                                dropLocationStore.clearDropLocation();
                            } }))),
                    react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                        react_1.default.createElement(BlocksTab_1.BlocksTab, { onClickToAdd: clickToAddCommonHandler, onDragAssetStart: dragStartCommonHandler, onDragAssetEnd: function () {
                                dragStore.stopDrag();
                                dropLocationStore.clearDropLocation();
                            } })),
                    react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                        react_1.default.createElement(ImageTab_1.ImageTab, { onClickToAdd: clickToAddCommonHandler, onDragAssetStart: dragStartCommonHandler, onDragAssetEnd: function () {
                                dragStore.stopDrag();
                                dropLocationStore.clearDropLocation();
                            }, openImageLibrary: openImageLibrary, fileInputRef: fileInputRef, onUpload: onUpload })),
                    react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                        react_1.default.createElement(VideoTab_1.VideoTab, { onClickToAdd: clickToAddCommonHandler, onDragAssetStart: dragStartCommonHandler, onDragAssetEnd: function () {
                                dragStore.stopDrag();
                                dropLocationStore.clearDropLocation();
                            } })))))));
});
var getMediaDataForVideo = function (asset, urlGenerator) { return __awaiter(void 0, void 0, Promise, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = {
                    url: asset.content.url
                };
                return [4, urlGenerator.getEmbedUrl(asset.content.url)];
            case 1: return [2, (_a.embedUrl = _b.sent(),
                    _a.thumbnailUrl = asset.content.thumbnail,
                    _a.type = Types_2.AssetType.Video,
                    _a.id = "",
                    _a)];
        }
    });
}); };
var cleanBlockData = function (asset) {
    var _a = asset.content, id = _a.id, savedBlockName = _a.savedBlockName, blockModel = __rest(_a, ["id", "savedBlockName"]);
    return blockModel;
};
var getMediaDataForUnsplashImage = function (asset) {
    return {
        url: asset.content.url,
        type: Types_2.AssetType.UnsplashImage,
        id: asset.content.id,
    };
};
